import type { AppState } from 'state/state.model';

import type { QuoteInfosState, QuoteInfosTab } from './quoteDetail.model';

const defaultTab: QuoteInfosTab = 'Details';

function selectTabPanel(state: AppState, tabId: string): QuoteInfosState | undefined {
  return state.uiPanel.quoteDetailUi[tabId];
}
export function getSelectedTab(state: AppState, tabId: string): QuoteInfosTab {
  return selectTabPanel(state, tabId)?.activeTab ?? defaultTab;
}

export function collapsedSections(state: AppState, tabId: string): string[] {
  const expandedSections = selectTabPanel(state, tabId)?.expanded ?? {};
  return Object.entries(expandedSections)
    .filter(entry => !entry[1])
    .map(entry => entry[0]);
}
